/**
 * Input Schema of CargaResponsavel
 * @author Simpli CLI generator
 */
import {Schema, FieldSet, FieldComponent, Component} from 'simpli-web-sdk'
import {CargaResponsavel} from '@/model/resource/CargaResponsavel'
import {CargaCollection} from '@/model/collection/CargaCollection'
import {EnderecoCollection} from '@/model/collection/EnderecoCollection'
import {ResponsavelCollection} from '@/model/collection/ResponsavelCollection'
import {ResponsavelFilialCollection} from '@/model/collection/ResponsavelFilialCollection'

/* TODO: review generated schema */
export class InputCargaResponsavelSchema extends Schema {
  collectionCarga = new CargaCollection().noPagination()
  collectionEndereco = new EnderecoCollection().noPagination()
  collectionResponsavel = new ResponsavelCollection().noPagination()
  collectionResponsavelFilial = new ResponsavelFilialCollection().noPagination()

  readonly name = 'InputCargaResponsavel'

  readonly fieldSet: FieldSet<CargaResponsavel> = {
    ehEmbarcador: (schema): FieldComponent => ({
      is: Component.InputCheckbox,
      bind: {
        label: this.translateFrom(schema.fieldName),
        class: 'pretty p-switch p-fill justify-center mt-8',
        labelClass: 'relative state',
      },
    }),
    carga: (schema): FieldComponent => ({
      is: Component.InputSelect,
      bind: {
        label: this.translateFrom(schema.fieldName),
        items: this.collectionCarga.all(),
      },
    }),
    endereco: (schema): FieldComponent => ({
      is: Component.InputSelect,
      bind: {
        label: this.translateFrom(schema.fieldName),
        items: this.collectionEndereco.all(),
      },
    }),
    responsavel: (schema): FieldComponent => ({
      is: Component.InputSelect,
      bind: {
        label: this.translateFrom(schema.fieldName),
        items: this.collectionResponsavel.all(),
      },
    }),
    responsavelFilial: (schema): FieldComponent => ({
      is: Component.InputSelect,
      bind: {
        label: this.translateFrom(schema.fieldName),
        items: this.collectionResponsavelFilial.all(),
      },
    }),
    inscricaoEstadual: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 63,
        label: this.translateFrom(schema.fieldName),
      },
    }),
    substitutoTributario: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 63,
        label: this.translateFrom(schema.fieldName),
      },
    }),
    inscricaoMunicipal: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 63,
        label: this.translateFrom(schema.fieldName),
      },
    }),
    municipioIcms: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 63,
        label: this.translateFrom(schema.fieldName),
      },
    }),
    cnaeFiscal: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 63,
        label: this.translateFrom(schema.fieldName),
      },
    }),
    codigoRegimeTributario: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 63,
        label: this.translateFrom(schema.fieldName),
      },
    }),
  }
}
